<template>
  <div class="notification-overlay text-center ma-2" >
    <v-snackbar
      v-model="visibility"
      :timeout="timeout"
      :content-class="backgroundClass"
      location="top end"
      position="fixed"
      width="400"
      min-height="68"
      
    >
      <slot />

      <template v-slot:actions>
        <v-btn
          color="white"
          variant="text"
          @click="visibility = false"
        >
          <v-icon size="18" class="px-4">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script setup lang="ts">
import NotificationType from '@/enum/NotificationType';
import { ref, computed } from 'vue';
import { VSnackbar } from 'vuetify/components';

const props = defineProps(['type', 'timeout', 'id', 'index'])
const visibility = ref(true);

const backgroundColors = {
  [NotificationType.Failed]: 'bg-red',
  [NotificationType.Success]: 'bg-success',
  [NotificationType.Info]: 'bg-info'
} as any; 

const backgroundClass = computed(() => backgroundColors[props.type] || 'bg-default');
</script>

<style scoped>
.notification-overlay {
  z-index: 100;
}

.bg-failed {
  background-color: #ffcccc !important;
}

.bg-success {
  background-color: #ccffcc !important;
}

.bg-info {
  background-color: #cce5ff !important;
}

.bg-default {
  background-color: rgb(55, 55, 55); 
}

.v-snackbar {
  opacity: 1 !important;
}
</style>
